import { render, staticRenderFns } from "./catalog-generations.vue?vue&type=template&id=37c82d9b"
import script from "./catalog-generations.vue?vue&type=script&lang=js"
export * from "./catalog-generations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports